module.exports = "<template>\r\n  <!--<require from=\"./add_user_dialog.scss\"></require>-->\r\n \r\n</template>";